import { render } from "./ProductCollections-page.vue?vue&type=template&id=4a0b1f7a"
import script from "./ProductCollections-page.vue?vue&type=script&lang=js"
export * from "./ProductCollections-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__